
export const validatePassword = (password: string): string | null => {
  const passwordRegex =
    /^(?=.*[a-z])(?=.*[A-Z])(?=.*\d)(?=.*[@$!%*?&])[A-Za-z\d@$!%*?&]{8,}$/;

  if (!password) {
    return "Password is required";
  } else if (!passwordRegex.test(password)) {
    return "Password must be at least 8 characters long and include uppercase, lowercase, number, and special character.";
  }
  return null;
};

export const validateConfirmPassword = (
  password: string,
  confirmPassword: string
): string | null => {
  if (!confirmPassword) {
    return "Please confirm your new password.";
  }
  if (password !== confirmPassword) {
    return "Passwords do not match.";
  }
  return null;
};